import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Fieldset.scss';

const Fieldset = ({ className, children }) => (
  <fieldset className={classNames('fieldset', className)}>{children}</fieldset>
);

Fieldset.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Fieldset;
